export default __webpack_public_path__ + "static/media/pulse.924d4eb1.png";